
<template>

  <div class="modal fade" id="uploadMediaModal">
    <div class="modal-dialog modal-dialog-centered custom-modal-two">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header">
              <div class="page-title">
                <h4>Medium</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-blocks">
                      <label>Media Title</label>
                      <input type="text" name="title" required v-model="media.title"
                             :class="{ 'form-control': true }" />
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="input-blocks">
                      <label>Description</label>
                      <input type="text" name="description" v-model="media.description"
                             :class="{ 'form-control': true }" />

                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-blocks">
<!--                      <label>Description</label>-->


                      <div class="d-flex my-2">
                        <a-image :width="0" :style="{ display: 'none' }" :preview="{
              visible,
              onVisibleChange: setVisible,
            }" :src="imagePreviewUrl"/>

                        <div v-if="imagePreviewUrl" class="image-container col-12 rounded" @mouseover="showOverlay = true"
                             @mouseleave="showOverlay = false">
                          <img :src="imagePreviewUrl" alt="Preview"/>
                          <div v-if="showOverlay" class="overlay">
                            <button @click="deleteImage" class="delete-btn">
                              <vue-feather type="trash-2"></vue-feather>
                            </button>
                            <button @click="openThumbnail(imagePreviewUrl)" class="zoom-btn">
                              <vue-feather type="zoom-in"></vue-feather>
                            </button>
                          </div>
                        </div>

                        <div class="file-upload " v-else>
                          <input type="file" @change="previewImage"/>

                          <span role="img" aria-label="plus" class="anticon anticon-plus">
                <svg focusable="false" data-icon="plus" width="1em" height="1em" fill="currentColor" aria-hidden="true"
                     viewBox="64 64 896 896">
                  <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path>
                  <path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path>
                </svg><!----></span>
                          <div class="file-upload-text">File</div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="modal-footer-btn">
                  <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-submit" id="submit" :disabled="isSubmitDisabled">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>

import { useMediaStore } from "@/store/mediaStore";
import { checkInputValidity } from '@/utils/validator';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import 'bootstrap/dist/css/bootstrap.min.css'; // if not already imported globally
import * as bootstrap from 'bootstrap';
// stores
const mediaStore = useMediaStore();

const showOverlay = ref(false);

const visible = ref(false);

const formTouched = ref(false);

const setVisible = (value) => {
  visible.value = value;
};
const imagePreviewUrl = ref("");

const props = defineProps({
  mediaId: null
});
// data
const media = ref({
  title: '',
  description: null,
  file: ''
});

const isSubmitDisabled = computed(() => {
  return !media.value.title || media.value.title.trim() === "";
});

// File Logic

function previewImage(event) {
  const file = event.target.files[0];
  if (file) {
    media.value.file = file;
    log(file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      imagePreviewUrl.value = reader.result;
    };
  }
}

function deleteImage() {
  imagePreviewUrl.value = "";
  media.value.file = null;
}

function openThumbnail(image) {
  imagePreviewUrl.value = image;
  setVisible(true);
}

async function submitForm() {

  const valid = checkInputValidity("submit");
  if (!valid) return;

  if (props.mediaId) {
    // update
    await mediaStore.updateMedia(props.mediaId, media.value);
  } else {
    // add
    await mediaStore.addMedia(media.value);
  }
  $("#uploadMediaModal").modal("hide");
}

// watch(() => media, () => {
//   // setTimeout is used here so the plan will be passed to the input b4 this runs
//   setTimeout(() => (
//       checkInputValidity("submit")), 10)
// }, { deep: true });

watch(() => props.mediaId, () => {
  if (props.mediaId) {
    media.value = mediaStore.media.find(m => m.id === props.mediaId);
    // media.value = found ? cloneDeep(found) : { title: '', description: '', file: null };
    imagePreviewUrl.value = media.value.url || '';
  } else {
    media.value = { title: '', description: '', file: null };
    imagePreviewUrl.value = '';
  }
}, { immediate: true });

const resetForm = () => {
  media.value = {
    title: '',
    description: '',
    file: ''
  };

  imagePreviewUrl.value = '';
  formTouched.value = false;
};

onMounted(() => {
  const modalEl = document.getElementById("uploadMediaModal");

  modalEl.addEventListener("hidden.bs.modal", () => {
    resetForm();
  });
});

</script>

<style scoped>

#uploadMediaModal.modal {
  z-index: 3000;
  background-color: transparent; /* Keep the default full-screen behavior */
}

#uploadMediaModal .modal-dialog {
  position: relative;
  z-index: 3001; /* Ensure the dialog content is above the overlay */
}

#uploadMediaModal .modal-dialog::before {
  content: '';
  position: fixed; /* Use fixed to cover the entire viewport, like the first modal's backdrop */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4); /* Lightly dim the background */
  z-index: -1; /* Place it just behind the .modal-dialog content */
}


/*
#uploadMediaModal.modal-backdrop {
  z-index: 2999 !important;
  opacity: 0.5 !important;
}
*/
</style>